import { polyfillScrollendEvent } from "./utils.js";

const template = document.createElement("template");

template.innerHTML = `
  <style>
    :host {
      --mask-gradient: rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 1) 48px, rgba(0, 0, 0, 1) calc(100% - 48px), rgba(0, 0, 0, 0) 100%;

      display: block;
      mask-image: linear-gradient(var(--mask-gradient)), linear-gradient(#000, #000);
      mask-position: 0 0, 100% 0;
      mask-repeat: no-repeat;
      mask-size: calc(100% - 12px) 100%, 12px 100%;
      overflow-y: auto;
      padding-inline-end: 12px;
    }

    :host([hidden]) {
      display: none;
    }

    :host([at-start]) {
      --mask-gradient: rgba(0, 0, 0, 1) calc(100% - 48px), rgba(0, 0, 0, 0) 100%;
    }

    :host([at-end]) {
      --mask-gradient: rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 1) 48px;
    }

    :host([at-start][at-end]) {
      --mask-gradient: #000, #000;
    }

    /* Works on Firefox */
    @supports (scrollbar-color: black white) {
      :host {
        scrollbar-color: var(--scrollbar-thumb-color) rgb(0 0 0 / 0%);
        scrollbar-width: thin;
      }
    }

    /* Works on Chrome, Edge, and Safari */
    :host::-webkit-scrollbar {
      width: 12px;
    }

    :host::-webkit-scrollbar-track {
      background: rgb(0 0 0 / 0%);
    }

    :host::-webkit-scrollbar-thumb {
      background: var(--scrollbar-thumb-color);
      border-radius: 999px;
      border: 3px solid rgb(0 0 0 / 0%);
      background-clip: padding-box;
    }
  </style>
  <slot></slot>
`;

export class TextScroller extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot!.appendChild(template.content.cloneNode(true));
  }

  connectedCallback() {
    this.setAttribute("at-start", "true");
    this.setAttribute("at-end", "true");
    if (this.scrollHeight > this.clientHeight) {
      this.#updateAttributes();
      if (!("onscrollend" in window)) polyfillScrollendEvent(this);
      this.addEventListener("scrollend", this.#updateAttributes);
    }
  }

  disconnectedCallback() {
    this.removeEventListener("scrollend", this.#updateAttributes);
  }

  #updateAttributes = () => {
    if (this.scrollTop > 5) {
      this.removeAttribute("at-start");
    } else {
      this.setAttribute("at-start", "true");
    }
    if (this.scrollTop + this.clientHeight < this.scrollHeight - 5) {
      this.removeAttribute("at-end");
    } else {
      this.setAttribute("at-end", "true");
    }
  };
}

"customElements" in window &&
  customElements.get("ws-text-scroller") === undefined &&
  customElements.define("ws-text-scroller", TextScroller);

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface HTMLElementTagNameMap {
    "ws-text-scroller": TextScroller;
  }
}
